import { createReducer } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { setAIFashionModels } from './actions'
import type { AIFashionModelsData } from './types'

export interface AIFashionModelsState {
  aiFashionModels: AIFashionModelsData | undefined
}

const initialState: AIFashionModelsState = {
  aiFashionModels: undefined,
}

export const aiFashionModelReducer = createReducer(initialState, builder => {
  builder.addCase(setAIFashionModels, (state, { payload }: PayloadAction<AIFashionModelsData>) => {
    state.aiFashionModels = payload
  })
})
